export default __webpack_public_path__ + "assets/images/5dc84450ff37188600f5f4d04a396b6c.svg";